// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addAccount } from "@insite/client-framework/Services/AccountService";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    CallAddAccount,
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import xLoadingOverlay from "@conklin/App/Handlers/XNG/LoadingOverlay";

type HandlerType = typeof PopulateApiParameter;

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", id: "create_user" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "clear", id: "create_user" }));
};

export const XngCallAddAccount: HandlerType = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await addAccount(props.apiParameter);
    watchForOtherTabSessionChange();
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
        // XNG-Changes: removing loading overlay in case of error to prevent infinite spinner
        props.dispatch(xLoadingOverlay({ key: "clear", id: "create_user" }));
        return false;
    }
};

addToStartOfChain(chain, setIsLoading);
addToEndOfChain(chain, setLoadingCompleted);
replaceInChain(chain, CallAddAccount, XngCallAddAccount);
